<template lang="pug">
  div.alert-wrapper
    transition-group(name="fade" tag="div" v-if='alerts')
      div.alert(
        :class="alert.type"
        v-for="(alert, index) in alerts"
        :key="`alert-${index}`")
        div.alert-body(v-html="alert.message")
        a.close-alert(@click="clear(alert)")
          svg.svgicon(xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" aria-hidden="true" focusable="false")
            path(d='M9.79 1.27a15.87 15.87 0 0 1 12.42 0 15.75 15.75 0 0 1 8.52 8.52 15.87 15.87 0 0 1 0 12.42 15.75 15.75 0 0 1-8.52 8.52 15.87 15.87 0 0 1-12.42 0 15.75 15.75 0 0 1-8.52-8.52 15.87 15.87 0 0 1 0-12.42 15.75 15.75 0 0 1 8.52-8.52zM16 30a13.69 13.69 0 0 0 5.44-1.11 14.13 14.13 0 0 0 4.47-3 14 14 0 0 0 3-4.46 13.92 13.92 0 0 0 0-10.89 13.76 13.76 0 0 0-7.45-7.45 13.92 13.92 0 0 0-10.89 0 14 14 0 0 0-4.46 3 14.13 14.13 0 0 0-3 4.47 13.92 13.92 0 0 0 0 10.89 13.7 13.7 0 0 0 7.44 7.44A13.72 13.72 0 0 0 16 30zm6.22-17.5l-3.5 3.5 3.5 3.5-2.72 2.72-3.5-3.5-3.53 3.5-2.69-2.72 3.5-3.5-3.5-3.5 2.69-2.72 3.53 3.5 3.5-3.5z')
</template>

<script>
import alertSvc from '@/services/alertSvc.js';

export default {
  name: 'TheAlert',
  data() {
    return {
      alerts: []
    };
  },
  methods: {
    clear: function(alert) {
      let idx = this.alerts.indexOf(alert);
      if (idx >= 0) {
        this.alerts.splice(idx, 1);
      }
    }
  },
  mounted() {
    alertSvc.onAlert((alert) => {
      if (alert.timeout) {
        setTimeout(() => this.clear(alert), alert.timeout);
      }
      this.alerts.push(alert);
    });
  }
};
</script>

<style lang="scss" scoped>
.alert-wrapper {
  position: fixed;
  top: $header-height;
  left: 0;
  z-index: 1000;
  width: 100%;

  // Transition group animation
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .alert {
    position: relative;
    max-width: $bp4;
    margin: 0 auto;
    padding: 13.5px 32px 13.5px 13.5px;

    &.success {
      background-color: $success-color;
    }
    &.error {
      background-color: $error-color;
    }

    .close-alert {
      position: absolute;
      top: 0;
      right: 0;
      padding: 13.5px;
      cursor: pointer;

      svg {
        display: block;
        height: 22px;
        width: 22px;
        color: #fff;
      }
    }

    .alert-body {
      line-height: 1.2;
      font-weight: 600;
      font-size: 1.125em;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
// Needed unscoped styles because of v-html use
// detailed info here: https://github.com/vuejs/vue-loader/issues/359
.alert-wrapper .alert-body a {
  color: #fff;
  text-decoration: underline;
}
</style>
